// extracted by mini-css-extract-plugin
module.exports = {"table_wrapper":"table_wrapper__kDSRsxSjUqXYI"};